import { registerJSONResolver } from '../../registry/jsonResolvers';
import { registerAutomotive, createAutomotiveFromJSON, } from '../../automotive/registryCore';
import '../../automotive/definitions';
export var automotivePlugin = {
    name: 'lightdraw-automotive',
    version: '1.2.1',
    install: function (LD) {
        registerJSONResolver(function (type, props, app) { return createAutomotiveFromJSON(type, props, app); });
        LD.registerAutomotive =
            registerAutomotive;
    },
};
export { registerAutomotive, createAutomotiveFromJSON };
export { listAutomotiveWidgets } from '../../automotive/registry';
export { installAutoWidgetResizeObserver, detachAutoWidgetResizeObserver, fitAutoWidgetToContainer, } from '../../automotive/responsive';
export { updateAutoWidgetProps, installAutoWidgetRebuild } from '../../automotive/refresh';
export { applyDriveState, sampleDriveFrames } from '../../automotive/simulation';
export { animateAutoValue, setAutoValue } from '../../automotive/helpers';
export { THEMES, getTheme, AUTOMOTIVE_THEME_PRESETS } from '../../automotive/themes';
export default automotivePlugin;
